import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './FunctionalDeficits.module.css';
import { AddButton } from '_components';
import { PatientCareCenterNoteSubjectiveFunctionalDeficitEntry } from './FunctionalDeficitEntry';
import { PatientCareCenterNoteSubjectiveFunctionalDeficitEntryCustom } from './FunctionalDeficitEntryCustom';


class PatientCareCenterNoteSubjectiveFunctionalDeficits extends React.Component {


    addFuncDef() {
        this.props.addChildRow(this.props.noteId, 'PTGOALS', 'GO', 'GOEVNO', this.props.evno);
    }

    addFuncDefCustom() {
        this.props.addCustomGoal(this.props.noteId);
    }


    render() {
        return (
            <PatientCareCenterNoteSection id='sub_med_hist_func_deficits' name='Functional Deficits' level={2} allowCollapse={true} >
                <div>
                    <div className={styles.row}>
                        <div className={styles.add_button} >
                            <AddButton title='Add Functional Deficit...' size='extra-small' onClick={() => this.addFuncDef()} />
                        </div>
                        <span>
                            <div className={styles.column_1_header}>Activity</div>
                            <div className={styles.column_2_header}>PLOF</div>
                            <div className={styles.column_3_header}>CLOF</div>
                            <div className={styles.column_4_header}>Goal</div>
                            <span className={styles.remove_button} />
                        </span>
                    </div>
                    {Object.keys(this.props.funcDefEntries)
                        .map(key => {
                            const result = this.props.funcDefEntries[key];
                            return (
                                <PatientCareCenterNoteSubjectiveFunctionalDeficitEntry key={result.GONO} id={result.GONO} />
                            )
                        })
                    }
                </div>
                <div>
                    <div className={styles.row}>
                        <div className={styles.add_button} >
                            <AddButton title='Add Custom Functional Deficit...' size='extra-small' onClick={() => this.addFuncDefCustom()} />
                        </div>
                        <span>
                            <div className={styles.column_1_header}>Custom</div>
                            <div className={styles.column_2_header}>PLOF</div>
                            <div className={styles.column_3_header}>CLOF</div>
                            <div className={styles.column_4_header}>Goal</div>
                            <span className={styles.remove_button} />
                        </span>
                    </div>
                    {Object.keys(this.props.funcDefEntriesCustom)
                        .map(key => {
                            const result = this.props.funcDefEntriesCustom[key];
                            return (
                                <PatientCareCenterNoteSubjectiveFunctionalDeficitEntryCustom key={result.GONO} id={result.GONO} />
                            )
                        })
                    }
                </div>
            </PatientCareCenterNoteSection>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        addChildRow: bindActionCreators(noteActions.addChildRow, dispatch),
        addCustomGoal: bindActionCreators(noteActions.addCustomGoal, dispatch),
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let evno = parseInt(noteId.split("_")[1]);
    let funcDefEntries = Object.keys(state.entities.notes.PTGOALS)
        .filter(key => {
            return state.entities.notes.PTGOALS[key].GOEVNO === evno
                && state.entities.notes.PTGOALS[key].GODELETED !== true
                && state.entities.notes.PTGOALS[key].GOMGNO !== parseInt(state.entities.masterData.PROPS['PTERO_IND_HEP_GOAL_ID'].PRVALUE)
                && state.entities.notes.PTGOALS[key].GOMGNO !== parseInt(state.entities.masterData.PROPS['PTERO_CUSTOM_GOAL_ID'].PRVALUE)
        })
        .sort((a, b) => state.entities.notes.PTGOALS[a].GONO - state.entities.notes.PTGOALS[b].GONO)
        .map(key => state.entities.notes.PTGOALS[key]);

    let funcDefEntriesCustom = Object.keys(state.entities.notes.PTGOALS)
        .filter(key => {
            return state.entities.notes.PTGOALS[key].GOEVNO === evno
                && state.entities.notes.PTGOALS[key].GODELETED !== true
                && state.entities.notes.PTGOALS[key].GOMGNO === parseInt(state.entities.masterData.PROPS['PTERO_CUSTOM_GOAL_ID'].PRVALUE)
        })
        .sort((a, b) => state.entities.notes.PTGOALS[a].GONO - state.entities.notes.PTGOALS[b].GONO)
        .map(key => state.entities.notes.PTGOALS[key]);

    return {
        noteId,
        evno,
        funcDefEntries,
        funcDefEntriesCustom,
    }
}
const connectedPatientCareCenterNoteSubjectiveFunctionalDeficits = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteSubjectiveFunctionalDeficits);
export { connectedPatientCareCenterNoteSubjectiveFunctionalDeficits as PatientCareCenterNoteSubjectiveFunctionalDeficits };

